import { FactoryProvider } from '@angular/core';
import { MmuLogLevel } from './mmu-log-level.enum';
import { MMU_LOG_LEVEL } from './mmu-log-level.token';
import { MmuDefaultLogger, MmuLogger } from './mmu-logger';


export const provideLogger = (name?: string): FactoryProvider => ({
  provide: MmuLogger,
  useFactory: (logLevel?: MmuLogLevel) => new MmuDefaultLogger(name, logLevel),
  deps: [MMU_LOG_LEVEL]
});
